// extracted by css-extract-rspack-plugin
export default {"menu":"MenuDropdown-module__menu","addFixed":"MenuDropdown-module__addFixed","container":"MenuDropdown-module__container","hidden":"MenuDropdown-module__hidden"};